import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';

import { StoreProvider, ErrorFlash, Label } from '../../components';
import { grantAdmin } from '../../mutations';

export class AdminNewView extends Component {
  state = {
    email: '',
    errors: null,
  };

  notify = () =>
    toast.success('Admin Successfully Created!', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });

  handleEmail = (event) => {
    this.setState({ email: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { lists, relay } = this.props;

    grantAdmin(relay.environment, this.state.email, lists.id, {
      onCompleted: this.handleSubmitSuccess,
      onError: this.handleSubmitFailure,
    });
  };

  handleSubmitSuccess = (response) => {
    let { errors } = response.grantAdmin;
    if (errors) {
      this.setState({ errors });
    } else {
      this.props.history.push('/admins');
      this.notify();
    }
  };

  render() {
    const { errors } = this.state;

    return (
      <div className="admin-new">
        <form className="admin-form" onSubmit={this.handleSubmit}>
          <div className="form-header">
            <h2>Add Admin</h2>
            <div className="form-header-actions">
              <input
                id="saveAdmin"
                className="admin-new-submit"
                type="submit"
                value="Save"
              />
            </div>
          </div>
          <div className="form-fields">
            <ErrorFlash errors={errors} />
            <div className="email-field">
              <Label attr="email" text="E-mail" errors={errors} />
              <input
                type="email"
                id="email"
                value={this.state.email}
                onChange={this.handleEmail}
                required
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const Container = withRouter(
  createFragmentContainer(AdminNewView, {
    lists: graphql`
      fragment AdminNew_lists on Lists {
        id
      }
    `,
  })
);

export default class AdminNew extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={Container}
        query={graphql`
          query AdminNewQuery {
            lists {
              ...AdminNew_lists
            }
          }
        `}
      />
    );
  }
}
